module.exports = __webpack_public_path__ + "static/media/bg_snowtrees.5ee5855b.jpg";